<template>
  <ModalConfirmation
    hasBlur
    :primaryButtonProps="modalContent.primaryButtonProps"
    :showModal="showModal"
    title="Save Command Template"
    @close="handleClose"
    @save="handleSave"
  >
    <template v-slot:body>
      <ParagraphBody
        v-for="text in modalContent.text"
        :key="text"
      >
        {{ text }}
      </ParagraphBody>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  ModalConfirmation,
  ParagraphBody,
  Types,
} from '@jumpcloud/ui-components';

const { PrimaryButtonProps } = Types;

export default {
  name: 'ModalEditCommandTemplate',

  components: {
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    showModal: Boolean,
  },

  computed: {
    modalContent() {
      const text = [
        'These changes do not affect commands that were previously created from this template.',
      ];

      return {
        primaryButtonProps: new PrimaryButtonProps({
          text: 'Save',
        }),
        text,
      };
    },
  },

  methods: {
    handleClose() {
      this.$emit('close');
    },

    handleSave() {
      this.$emit('save');
    },
  },
};
</script>
